import { render, staticRenderFns } from "./BtnFiltroCentralPedidos.vue?vue&type=template&id=df2ca5ba&"
import script from "./BtnFiltroCentralPedidos.vue?vue&type=script&lang=js&"
export * from "./BtnFiltroCentralPedidos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports